import { createGlobalStyle } from 'styled-components';

import NLRTM from '../../../assets/fonts/NLRTM.woff2';
import NLRTMBold from '../../../assets/fonts/NLRTM-Bold.woff2';

// typed as 'any' due to an incompatibilty between @types/styled-components and @types/react 18.x
// can be removed once @types/styled-components is updated
export const GlobalStyle: any = createGlobalStyle`
  @font-face {
    font-family: 'NLRTM-Bold';
    src: local('NLRTM-Bold'), url(${NLRTMBold}) format('woff2');
  }

  @font-face {
    font-family: 'NLRTM';
    src: local('NLRTM'), url(${NLRTM}) format('woff2');
  }

  html {
    box-sizing: border-box;
    min-height: 100%;
    height: 100%;
    font-family: NLRTM, sans-serif;
    font-weight: normal;
    color: ${({ theme }) => theme.colors.text.primary};
  }

  [hidden] {
    display: none !important;
  }

  *,
  *::after,
  *::before {
    box-sizing: inherit;
    transition: color 0.3s ease, background-color 0.3s ease;
  }

  body {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    font-family: NLRTM, sans-serif;
  }

  p, button, a {
    font-family: NLRTM, sans-serif;
    font-size: 14px;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: NLRTM-Bold, sans-serif;
    font-weight: bold;
  }
`;
